import APIContext from 'contexts/base/APIContext'

export default class AuditsContext extends APIContext {
  static contextName = 'audits';
}
